<template>
  <form class="needs-validation" @submit.prevent="saveMembers" novalidate>
    <div class="col px-0 pr-lg-3">
      <section class="bg-white rounded mb-4 p-3 p-sm-4" v-for="(memberDetail, index) in memberPages" :key="index">
        <h1 class="h2 mb-3" v-if="index === 0">Add Member</h1>
        <div role="alert" class="alert alert-warning" v-if="errors[index]">{{errors[index]}}</div>
        <div role="alert" class="alert alert-warning" v-if="commonError">{{commonError}}</div>
        <div class="row align-items-start">
          <div class="col-12 col-md-6 form-group row no-gutters">
            <div class="col-auto">
              <label :for="`title${index}`">Title</label>
              <select class="form-control" :id="`title${index}`" required v-model="memberUpdate[index].title">
                <option disabled></option>
                <option value="Mr">Mr</option>
                <option value="Ms">Ms</option>
                <option value="Miss">Miss</option>
                <option value="Mrs">Mrs</option>
                <option value="Dr">Dr</option>
              </select>
              <div class="invalid-tooltip">Please include the title.</div>
            </div>

            <div class="col pl-3">
              <label :for="`firstName${index}`">First Name</label>
              <input type="text" class="form-control" :id="`firstName${index}`" required v-model="memberUpdate[index].first_name" maxlength="40">
              <div class="invalid-tooltip">Please include the First Name.</div>
            </div>
          </div>
          <div class="col-12 col-md-6 form-group">
            <label :for="`lastName${index}`">Last Name</label>
            <input type="text" class="form-control" :id="'lastName' + index" required v-model="memberUpdate[index].last_name" maxlength="40">
            <div class="invalid-tooltip">Please include the Last Name.</div>
          </div>
          <div class="col-12 col-xl-6 row no-gutters">
            <div class="col-12 col-md-6 col-xl-auto form-group mb-xl-0 pr-md-3 pr-xl-0">
              <label :for="`gender${index}`">Gender</label>
              <select class="form-control" :id="'gender' + index" v-model="memberUpdate[index].gender" required>
                <option disabled></option>
                <option>Male</option>
                <option>Female</option>
                <option>Unspecified</option>
              </select>
              <div class="invalid-tooltip">Please include the Gender.</div>
            </div>

            <div class="col-12 col-md-6 col-xl form-group mb-xl-0 pl-md-3">
              <label :for="`riderStatus${index}`">Rider Status</label>
              <select class="form-control" :id="'riderStatus' + index" required v-model="memberUpdate[index].riderStatus">
                <option disabled></option>
                <option v-for="(status, statusIndex) in $store.state.riderStatus" :key="statusIndex">{{status.name}}</option>
              </select>
              <div class="invalid-tooltip">Please include the Rider Status.</div>
            </div>

          </div>
          <div class="col-12 col-md-6 form-group" v-if="(userRole === 'Admin' || userRole === 'SuperAdmin')">
            <label for="boyStatus">Beginning of Year Status</label>
            <select class="form-control" id="boyStatus" required v-model="memberUpdate[index].boy_status_id">
              <option disabled :selected="!memberUpdate[index].boy_status_id"></option>
              <option v-for="(status, statusIndex) in $store.state.riderStatus" :key="statusIndex" :value="status.id" :selected="memberUpdate[index].boy_status_id === status.id">{{status.name}}</option>
            </select>
            <div class="invalid-tooltip">Please include the Rider Status.</div>
          </div>
          <div class="col-12 col-md-6 no-gutters form-group">
            <label :for="`dateOfBirth${index}`">Date of Birth</label>
            <input :max="today()" :class="['form-control form-date', errorStatus === 'validation_error' && errors[index] ? 'is-invalid' : '']" :id="'dateOfBirth' + index" type="date" :placeholder="[isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy']" pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}" value="1988-01-01" required v-model="memberUpdate[index].dateOfBirth" @change="calcType(index)">
            <div class="invalid-tooltip">Please include the Date of Birth.</div>
          </div>
          <div class="col-12 col-md-6 form-group">
            <label :for="`secondary_email${index}`">Email</label>
            <input type="email" :class="['form-control', errorStatus === 'secondary_email' ? 'is-invalid' : '']" :id="`secondary_email${index}`" v-model="memberUpdate[index].secondary_email" maxlength="40">
            <div class="invalid-tooltip">Please include correct the email.</div>
          </div>
          <div class="col-12 col-md-6 form-group">
            <label :for="`secondary_phone${index}`">Mobile number</label>
            <phone-input :class="[errorStatus === 'incorrect_phone' ? 'is-invalid' : '']" :id="`secondary_phone${index}`" v-model="memberUpdate[index].secondary_phone" />
            <div class="invalid-tooltip">{{ errorStatus === 'incorrect_phone' ? 'Please include correct phone number.' : 'Please include your phone number.' }}</div>
            <small>Please enter the phone in a similar format +614 **** **** without spaces</small>
            <test-phone-numbers />
          </div>
          <div class="col-12 col-md-6 form-group">
            <label for="carbon_copy_mobile">CC Mobile <small class="d-inline-block">(optional)</small></label>
            <phone-input :class="[errorStatus === 'carbon_copy_mobile' ? 'is-invalid' : '']" :id="`carbon_copy_mobile${index}`" v-model="memberUpdate[index].carbon_copy_mobile" />
            <div class="invalid-tooltip">Please enter correct CC mobile</div>
            <small>Please enter the phone in a similar format +614 **** **** without spaces</small>
            <test-phone-numbers />
          </div>
          <div class="col-12 col-md-6 no-gutters form-group">
            <label for="proofOfAge">Proof of Age</label>
            <div class="custom-file">
              <input type="file" :class="['custom-file-input font-weight-normal', { 'is-invalid': errorStatus === 'file' }]" id="proofOfAge" accept="image/*, application/pdf" @change="fileUpload($event, index)">
              <label class="custom-file-label font-weight-normal" for="proofOfAge">{{memberUpdate[index].file_name ? memberUpdate[index].file_name : 'Choose file...'}}</label>
              <small>jpg, jpeg, png, tiff, gif, pdf file type required.</small>
              <br>
              <small>Your ID will be stored in a secure data storage</small>
              <button
              v-if="memberUpdate[index].file_name"
              type="button"
              class="btn btn-link px-2 pl-md-0 px-xl-2 pr-md-1"
              @click="deleteAttachment(index)"
              >
              <span class="sr-only">Delete File</span>
              <div class="btn-remove">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" aria-hidden="true" viewBox="0 0 17 17"><g fill="currentColor"><path d="M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"/><path d="M10.6 11.1c-.1 0-.3 0-.4-.1L6 6.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.2 4.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"/><path d="M6.4 11.1c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l4.2-4.2c.2-.2.5-.2.7 0s.2.5 0 .7L6.7 11s-.2.1-.3.1z"/></g></svg>
              </div>
              </button>
            </div>
          </div>
          <div class="col-12 col-md-6 form-group" v-if="(userRole === 'Admin' || userRole === 'SuperAdmin')">
            <label :for="`memberNumber${index}`">Member Number</label>
            <input  :class="['form-control', errorStatus === 'member_number' ? 'is-invalid' : '']"  type="text" class="form-control" :id="`memberNumber${index}`" v-model="memberUpdate[index].member_number">
            <div class="invalid-tooltip">{{ errorStatus === 'member_number' ? 'Please include another member number.' : '' }}</div>
          </div>
          <div class="col-12 d-flex flex-wrap justify-content-end">
            <button class="btn btn-outline-primary btn-block-mob mt-3 mb-2 mb-lg-0" @click="memberUpdate.splice(index,1);memberPages--" v-if="memberPages > 1">Remove</button>
            <button :class="['d-block d-lg-none btn btn-block-mob btn-primary text-nowrap', memberPages > 1 ? '' : 'mt-3']" @click.prevent="memberUpdate.push({name:{}});memberPages++;resetForm()">Add Another</button>
          </div>
        </div>
      </section>

      <button class="d-lg-none btn btn-block btn-primary mb-3" type="submit" :disabled="this.errors.length !== 0 && this.commonError" @click="handleSubmit">Finalise List</button>
    </div>

    <desktop-action-bar>
      <button class="d-none d-lg-block btn btn-block btn-outline-primary text-nowrap" @click.prevent="memberUpdate.push({name:{}, notes: '', file_name: ''});memberPages++;resetForm()">Add Another</button>
      <button :class="['btn btn-block mb-2', processing ? 'btn-primary-dark' : 'btn-primary']" @click="handleSubmit" type="submit">
        {{ !processing ? 'Finalise List' : '' }}
        <div v-if="processing" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
      </button>
    </desktop-action-bar>
  </form>
</template>

<script>
import axios from 'axios'
import HANDLESUBMIT from '@/mixins/formValidation.js'
import LEGACYBROWSERS from '@/mixins/legacyBrowsers.js'
import CALCTYPE from '@/mixins/calcType.js'
import _ from "lodash"
import DesktopActionBar from '@/components/DesktopActionBar'
import PhoneInput from '@/components/FormFields/PhoneInput'
import TestPhoneNumbers from '@/components/TestPhoneNumbers'

export default {
  name: 'MemberAddDetails',
  props: ['details'],
  mixins: [HANDLESUBMIT, CALCTYPE, LEGACYBROWSERS],
  components: {
    TestPhoneNumbers,
    PhoneInput,
    DesktopActionBar
  },
  data() {
    return {
      memberPages: 1,
      memberUpdate: [{ notes: '', file_name: '' }],
      memberTypesCount: {},
      userID: localStorage.userID,
      userRole: localStorage.role,
      processing: false,
      errorStatus: '',
      errors: [],
      commonError: '',
      files: []
    }
  },
  mounted() {
    if ((this.userRole === 'Admin' || this.userRole === 'SuperAdmin')) {
      setTimeout(() => {
        if (this.$store.state.viewedMember === '' && this.$store.state.childMember === '') {
          this.$router.push('/')
        }
      }, 1)
    }
  },
  methods: {
    setPrice(index) {
      this.memberUpdate[index].price = this.$store.state.products[index].price
      this.getTotal()
    },
    getTotal() {
      // eslint-disable-next-line
      this.memberTypesCount = this.memberUpdate.reduce((member, o) => (member[o.type] = (member[o.type] || 0) + 1, member), {})
      delete this.memberTypesCount.undefined

      /* Do Couples/Family Discount */
      if (this.memberTypesCount.Adult > 1) {
        let couples = Math.floor(this.memberTypesCount.Adult / 2)

        if (this.memberTypesCount.Juvenile > 0 && (this.memberTypesCount.Junior > 0 || this.memberTypesCount.Mini > 0)) {
          let families = null
          if (this.memberTypesCount.Junior > 0 && this.memberTypesCount.Mini > 0) {
            families = Math.min(couples, Math.min(this.memberTypesCount.Juvenile, (Math.max(this.memberTypesCount.Junior, this.memberTypesCount.Mini))))
          } else if (this.memberTypesCount.Junior > 0) {
            families = Math.min(couples, Math.min(this.memberTypesCount.Juvenile, this.memberTypesCount.Junior))
          } else {
            families = Math.min(couples, Math.min(this.memberTypesCount.Juvenile, this.memberTypesCount.Mini))
          }
          // this.memberTypesCount.Juvenile -= families
          // this.memberTypesCount.Junior -= families
          // this.memberTypesCount.Adult -= families * 2
          couples -= families

          this.memberTypesCount['Family Discount'] = families
        }

        if (couples > 0) {
          // this.memberTypesCount.Adult -= couples * 2
        }

        this.memberTypesCount['Couples Dicsount'] = couples
        /* Remove keys from cart with zero in them */
        Object.keys(this.memberTypesCount).forEach(key => (this.memberTypesCount[key] === 0) && delete this.memberTypesCount[key])
      }
    },
    saveMembers() {
      setTimeout(() => {
        if (this.formComplete && this.errors.length === 0 && !this.commonError) {
          this.processing = true
          const membersSend = this.memberUpdate.map((member) => {
            member.dob = member.dateOfBirth
            member.rider_status_id = this.$store.state.riderStatus.filter(item => item.name === member.riderStatus)[0].id
            return member
          })
          const fields = {
            primary_id: (this.userRole !== 'Admin' && this.userRole !== 'SuperAdmin') ? this.userID : this.$store.state.viewedMember ? this.$store.state.viewedMember.primary ? this.$store.state.viewedMember.primary.id : this.$store.state.viewedMember.id : this.$store.state.childMember ? this.$store.state.childMember.primary.id : null,
            secondaries: membersSend
          }
          const formData = new FormData()
          for (let i = 0; i < this.files.length; i++) {
            const file = this.files[i]
            if (this.files[i] && this.files[i].size > 1024 * 1024) {
              this.errorStatus = 'file'
              this.errors[i] = `The Proof of Age file may not be greater than 1 mb.`
            }
            formData.append(`files[${i}]`, file)
          }
          formData.append('fields', JSON.stringify(fields))
          axios.post(`${this.$api}/add-secondary`, formData).then((response) => {
            this.errors = []
            // eslint-disable-next-line
            // console.log(response.data)
            this.processing = false
            if (response.data.status === 'success') {
              const users = response.data
              users.users = this.memberUpdate
              // this.$store.commit('updateCartMembers', users)
              this.$router.push({ name: this.$isAdmin ? 'Member Profile' : 'My Profile', params: { renewing: true, tabSelect: 'details', details: this.$store.state.viewedMember || this.$store.state.childMember ? this.$store.state.childMember : undefined } })
            } else if (response.data.status === 'validation_error' && Object.keys(response.data.errors).filter(k => k.includes("dob")).length > 0) { // Do any keys in the error object contain the text 'dob'?
              // DoB
              this.errorStatus = 'validation_error'
              this.errors[Object.keys(response.data.errors).filter(k => k.includes("dob"))[0].match(/\d+/)[0]] = `Please include the Date of Birth in the format${this.isLegacy() ? ' yyyy-mm-dd' : ' dd/mm/yyyy'}.`
            } else if (Object.keys(response.data.errors).filter(k => k.includes("first_name")).length > 0) {
              this.errors[Object.keys(response.data.errors).filter(k => k.includes("first_name"))[0].match(/\d+/)[0]] = `Please include a First Name with a maximum of 40 characters.`
            } else if (Object.keys(response.data.errors).filter(k => k.includes("last_name")).length > 0) {
              this.errors[Object.keys(response.data.errors).filter(k => k.includes("last_name"))[0].match(/\d+/)[0]] = `Please include a Last Name with a maximum of 40 characters.`
            } else if (response.data.status === 'validation_error' && Object.keys(response.data.errors).filter(k => k.includes("secondary_phone")).length > 0) {
              this.errorStatus = 'incorrect_phone'
              this.errors[Object.keys(response.data.errors).filter(k => k.includes("secondary_phone"))[0].match(/\d+/)[0]] = `Please include correct phone number.`
            } else if (response.data.status === 'validation_error' && Object.keys(response.data.errors).filter(k => k.includes("secondary_phone")).length > 0) {
              this.errorStatus = 'carbon_copy_mobile'
              this.errors[Object.keys(response.data.errors).filter(k => k.includes("carbon_copy_mobile"))[0].match(/\d+/)[0]] = `Please include correct CC mobile.`
            } else if (response.data.status === 'validation_error' && Object.keys(response.data.errors).filter(k => k.includes("member_number")).length > 0) {
              this.errorStatus = 'member_number'
              this.errors[Object.keys(response.data.errors).filter(k => k.includes("secondary_phone"))[0].match(/\d+/)[0]] = `The member number has already been taken.`
            } else if (response.data.status === 'validation_error' && Object.keys(response.data.errors).filter(k => k.includes("secondary_email")).length > 0) {
              this.errorStatus = 'secondary_email'
              this.errors[Object.keys(response.data.errors).filter(k => k.includes("secondary_email"))[0].match(/\d+/)[0]] = `Please include correct email address`
            } else if (response.data.status === 'validation_error' && Object.keys(response.data.errors).filter(k => k.includes("file")).length > 0) {
              this.errorStatus = 'file'
              this.errors[Object.keys(response.data.errors)
                .filter(k => k.includes("secondary_email"))[0].match(/\d+/)[0]] = `The Proof of Age file may not be greater than 1 mb.`
            }
          }).catch((error) => {
            if (error.response.status === 413) {
              this.success = ''
              this.errorStatus = 'file'
              this.commonError = `The Proof of Age file may not be greater than 1 mb.`
            }
            this.errors = []
            this.processing = false
            // eslint-disable-next-line
            console.log(error)
          })
        }
      }, 10)
    },
    getPrice(type, typeKey) {
      let result = null
      if (this.$store.state.products.filter(item => item.name === typeKey).length > 0) {
        result = (this.$store.state.products.filter(item => item.name === typeKey)[0].price * type).toFixed(2)
      } else {
        result = (this.$store.state.discounts.filter(item => item.name === typeKey)[0].price * type).toFixed(2)
      }
      return result
    },
    fileUpload(event, index) {
      this.errorStatus = ''
      this.memberUpdate[index].file_name = ''
      // eslint-disable-next-line
      _.remove(this.errors, (value, ind)=> {
        return ind === index
      })
      const uploadedFile = event.target.files[0]
      this.files[index] = uploadedFile
      if (uploadedFile && this.files[index].size > 1024 * 1024) {
        this.errorStatus = 'file'
        this.errors[index] = `The Proof of Age file may not be greater than 1 mb.`
      }
      if (uploadedFile) {
        this.memberUpdate[index].file_name = uploadedFile.name
      }
    },
    deleteAttachment(index) {
      delete this.files[index]
      this.files[index] = undefined
      this.memberUpdate[index].file_name = ''
      this.errorStatus = ''
      // eslint-disable-next-line
      _.remove(this.errors, (value, ind)=> {
        return ind === index
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-pane {

  section.rounded:first-child {
    border-top-left-radius: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/MyMembership/Add/MemberAddDetails.vue